import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { paymentFormLegacyDefaultDataSchema } from './data';

/**
 * Default-placement legacy payment-form envelope.
 *
 * `type` is `z.literal('default').optional()` so that persisted entities
 * written before the discriminator existed (which omit `type` entirely) parse
 * here, and the zod discriminated union in `./entity.ts` falls through to this
 * branch when the field is missing. Mirrors the form widget's envelope.
 */
export const paymentFormLegacyDefaultV0Schema = z.object({
    id: z.string(),
    name: z.literal('payment'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().nullish(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('default').optional(),
    data: paymentFormLegacyDefaultDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
